module.exports = __webpack_public_path__ + "img/13.7f55c039.webp";